import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { style } from 'styled-system';
import { Text } from 'roo-ui/components';
import formatNumber from 'lib/formatters/formatNumber';

const qffFormatter = (points) => formatNumber({ number: points, decimalPlaces: 0 });

const textDecoration = style({
  prop: 'textDecoration',
  cssProperty: 'textDecoration',
});

const Points = styled(Text)`
  ${textDecoration}
`;

const PointsEarnDisplay = ({ total, base, ...rest }) => {
  const formattedTotal = qffFormatter(total);
  const formattedBase = qffFormatter(base);
  const hasBonus = base > 0 && base < total;
  const totalColor = hasBonus ? 'brand.primary' : '';
  return (
    <Fragment>
      {hasBonus && (
        <Fragment>
          <Points {...rest} textDecoration="line-through">
            {formattedBase}
          </Points>{' '}
        </Fragment>
      )}
      <Points fontWeight="bold" {...rest} color={totalColor} data-testid="total-points-displayed">
        {formattedTotal}
      </Points>
    </Fragment>
  );
};

PointsEarnDisplay.propTypes = {
  base: PropTypes.number,
  total: PropTypes.number.isRequired,
};

PointsEarnDisplay.defaultProps = {
  base: undefined,
};

export default PointsEarnDisplay;
